import React, { Component } from 'react'
import { FormattedMessage, FormattedDate, injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

class OrderStatusSelect extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            options: this.setOptions(),
            selectedOptions: this.props.value || [],
            multi: this.props.multi || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    setOptions() {

        const orderStatusTypes = !this.props.isItemReport ? ['draft', 'ordered', 'completed'] : ['ordered', 'completed']
        let options = [];
        for (let statusType of orderStatusTypes) {

            let option = AppContext.getOrderStatusesByType(statusType).map(s => {
                return {
                    value: s.id,
                    label: s.attributes.name
                }
            })
            options = options.concat(option)
        }

        return options
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOptions: selectedOption
        }, () => {
            if (selectedOption) {
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => option.value), selectedOption.map(option => option.label).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            } else {
                this.onChange("", "")
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(OrderStatusSelect)





// WEBPACK FOOTER //
// ./src/order/statusesselection.component.jsx